"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Dissolved = function Dissolved(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    height: "10",
    viewBox: "0 0 10 10",
    width: "10",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m2.47 2.32a.4.4 0 0 1 -.29-.12l-.84-.83a.42.42 0 0 1 .59-.59l.83.83a.41.41 0 0 1 0 .59.4.4 0 0 1 -.29.12z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m3.75 1.87a.4.4 0 0 1 -.41-.41v-1a.41.41 0 0 1 .41-.46.43.43 0 0 1 .42.42v1a.42.42 0 0 1 -.42.45z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m2 3.75h-1a.41.41 0 0 1 -.41-.42.41.41 0 0 1 .41-.41h1a.41.41 0 0 1 .42.41.42.42 0 0 1 -.42.42z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m2.31 10a1.83 1.83 0 0 1 -1.31-.55l-.45-.45a1.88 1.88 0 0 1 0-2.65l1.45-1.41a.42.42 0 0 1 .59.59l-1.45 1.47a1 1 0 0 0 0 1.47l.44.44a1 1 0 0 0 1.47 0l1.41-1.46a.4.4 0 0 1 .59 0 .39.39 0 0 1 0 .58l-1.41 1.42a1.87 1.87 0 0 1 -1.33.55z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m8.07 7.5h-1.87a.41.41 0 0 1 -.41-.42.41.41 0 0 1 .41-.41h1.87a1.08 1.08 0 0 0 1.1-1v-.85a1.12 1.12 0 0 0 -1.09-1.07h-1.88a.41.41 0 0 1 -.41-.42.41.41 0 0 1 .41-.41h1.88a1.94 1.94 0 0 1 1.92 1.9v.84a1.89 1.89 0 0 1 -1.93 1.84z"
  }));
};

var _default = Dissolved;
exports["default"] = _default;